var render = function render(){var _vm=this,_c=_vm._self._c;return _c('laboratory-profile-component')
}
var staticRenderFns = []

export { render, staticRenderFns }